import { LOGIN, LOG_OUT } from "../constant";

export const login = (data) => {
  return {
    type: LOGIN,
    payload: {
      group: data.group,
      userName: data.userName,
      parkID: data.parkID,
    },
  };
};

export const logout = () => {
  return {
    type: LOG_OUT,
  };
};
